import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { ReviewItemStoreModel, ReviewItemUIModel } from './review-item.model';
import { ReviewItemState, ReviewItemStore } from './review-item.store';

@Injectable({ providedIn: 'root' })
export class ReviewItemQuery extends QueryEntity<ReviewItemState, ReviewItemStoreModel, ReviewItemUIModel, 'id'> {
  constructor(protected override store: ReviewItemStore) {
    super(store);
  }

  selectSession() {
    return this.select((state) => state.props.session);
  }
}
